import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import ProductionPublishContent, { getPublishAccess } from './ProductionPublishContent';

const PublishProjectModal = ({
  projectId,
  version,
  versions,
  selVersion,
  isPublishing,
  popoverOpen,
  toggle,
  handleVersionChange,
  publishApp,
  projectDetail,
  actions,
  isReadOnly,
}) => {
  const { disable } = getPublishAccess(projectDetail, projectId);

  return (
    <Modal size="lg" isOpen={popoverOpen} toggle={toggle} backdrop="static" className="publish">
      <ModalHeader toggle={toggle} className="border-bottom">
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ width: '48rem' }}
        >
          <strong>Publish your app for the end users.</strong>
          {!disable ? (
            <Link
              to={{
                pathname: `/deployment-setting/${version}/v/${projectId}/code-export`,
              }}
              className="btn btn-theme-submit"
              title="Code Export"
            >
              <i className="wb webconnect-cursor-fill"></i>&nbsp;Export Code
            </Link>
          ) : null}
        </div>
      </ModalHeader>
      <ModalBody>
        <ProductionPublishContent
          variant="table"
          projectId={projectId}
          version={version}
          versions={versions}
          selVersion={selVersion}
          isPublishing={isPublishing}
          handleVersionChange={handleVersionChange}
          publishApp={publishApp}
          projectDetail={projectDetail}
          actions={actions}
        />
      </ModalBody>
    </Modal>
  );
};

export default PublishProjectModal;
